export const PALETTE_COLUMN_LABEL_SERIOUS = "serious";
export const PALETTE_COLUMN_LABEL_STANDARD = "standard";
export const PALETTE_COLUMN_LABEL_FUN = "fun";

export const PALETTE_COLUMN_VALUE_SERIOUS = "serious";
export const PALETTE_COLUMN_VALUE_STANDARD = "standard";
export const PALETTE_COLUMN_VALUE_FUN = "fun";

export const PALETTE_ROW_NEUTRAL = "neutral";
export const PALETTE_ROW_BOLD = "bold";
export const PALETTE_ROW_GRAY = "gray";
export const PALETTE_ROW_PRIMARY = "primary";
export const PALETTE_ROW_SECONDARY = "secondary";
export const PALETTE_ROW_TERTIARY = "tertiary";
export const PALETTE_ROW_ACCENT = "accent";
export const PALETTE_ROW_WARNING = "warning";
export const PALETTE_ROW_CELEBRATION = "celebration";

export const PALETTE_COLUMN_1 = PALETTE_COLUMN_VALUE_SERIOUS;
export const PALETTE_COLUMN_2 = PALETTE_COLUMN_VALUE_STANDARD;
export const PALETTE_COLUMN_3 = PALETTE_COLUMN_VALUE_FUN;

export const COLOR_PALETTE_COLUMNS = [
  { label: PALETTE_COLUMN_LABEL_SERIOUS, value: PALETTE_COLUMN_1 },
  { label: PALETTE_COLUMN_LABEL_STANDARD, value: PALETTE_COLUMN_2 },
  { label: PALETTE_COLUMN_LABEL_FUN, value: PALETTE_COLUMN_3 },
];

export const CONTRAST_LIGHT_MODE = "light-mode";
export const CONTRAST_DARK_MODE = "dark-mode";
